import { render, staticRenderFns } from "./PagesList.vue?vue&type=template&id=0bd25458"
import script from "./PagesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PagesList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PagesList.vue?vue&type=style&index=0&id=0bd25458&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports